import styled from 'styled-components';

export const BestsellerContainer = styled.div`
  padding-top: 50px;
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (max-width: 720px) {
    padding-top: 35px;
    padding-bottom: 0px;
  }

  .bestseller {
    font-size: clamp(22px, 2vw, 42px);
    font-weight: 600;
    color: #675b5a;
  }
  .adore {
    font-size: clamp(22px, 2vw, 42px);
    font-weight: 600;
    text-align: left;
    color: #7e5c5c;
  }
  .elementContainer {
    padding-top: 25px;
    gap: 40px;
    cursor: pointer;
    display: flex;
    ::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 720px) {
      gap: 12px;
      padding-top: 25px;
      cursor: none;
      overflow-x: scroll;
      scroll-behavior: smooth;
      -webkit-box-pack: start;
      justify-content: flex-start;
      width: 100%;
      padding-left: 12px;
      padding-bottom: 10px;
    }
    .tabContainer {
      padding: 16px 40px;
      border-radius: 10px;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
      background-color: #fff;
      color: rgba(0, 0, 0, 0.65);
      font-weight: 500;
      @media (min-width: 720px) {
        p {
          font-size: 20px;
        }
      }

      @media (max-width: 720px) {
        padding: 8px 12px;
        font-size: 14px;
      }
    }

    .selected {
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.16);
      background-color: #ef4e5e;
      color: rgba(255, 255, 255, 1);
      font-weight: 600;
    }
  }
  .productContainer {
    padding-top: 18px;
    width: 70%;
    display: grid;
    -webkit-box-pack: start;
    justify-content: flex-start;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    @media (max-width: 720px) {
      grid-template-columns: repeat(2, 1fr);
      width: 100%;
      padding: 8px;
      gap: 4px;

      .video-card {
        flex-basis: 44%;
        margin: 4px 10px;
        border-radius: 8px;
      }

      .video-player {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: inherit;
      }
    }
    .variantType {
      margin-top: 10px;
      padding: 3px 8px;
      border-radius: 7px;
      background-color: #ebebeb;
      width: max-content;
      p {
        font-size: clamp(9px, 2vw, 14px);
        color: rgba(0, 0, 0, 0.6);
        font-weight: 500;
      }
    }
    .productNameNew {
      font-size: clamp(13px, 2vw, 18px);
      font-weight: 600;
      color: rgba(0, 0, 0, 0.87);
    }
  }

  .viewAllButton {
    border-radius: 10px;
    background-color: #ef4e5e;
    width: 35%;
    padding: 16px;
    margin-top: 34px;
    cursor: pointer;
    p {
      font-size: clamp(16px, 2vw, 22px);
      font-weight: 600;
      text-align: center;
      color: rgba(255, 255, 255);
    }
    @media (max-width: 720px) {
      width: 93%;
      padding: 12px;
      margin-top: 5px;
      cursor: inherit;
    }
  }
`;
